import {
  ResourceType,
  Role,
  User,
  UsersById,
} from '@energybox/react-ui-library/dist/types';
import {
  mapArrayToObject,
  mapValues,
} from '@energybox/react-ui-library/dist/utils';
import * as R from 'ramda';
import { Actions } from '../actions/users';

export interface Users {
  usersById: UsersById;
}

export type ActionsLoadingStatus = {
  [Actions.GET_USERS_LOADING]?: boolean;
};

export const mapScopeToAccessResource = scope => ({
  id: scope.id,
  role: Role[scope.role],
  resourceType: ResourceType[(scope.resource._entity as string).toUpperCase()],
  resourceId: scope.resource.id,
  title: scope.resource.title,
});

function userFromApiResponse(data: any): User {
  return {
    id: data.id,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    lastLogin: data.lastLoginAt || undefined,
    role: data.role || undefined,
    position: data.position || '',
    timeZone: data.timeZone,
    measurementSystem: data.measurementSystem,
    organizationUnitTitle: data.organizationUnit && data.organizationUnit.title,
    organizationUnitId: data.organizationUnit && data.organizationUnit.id,
    accessResources: data.scopes.map(mapScopeToAccessResource),
    groupIds: data.groups ? data.groups.map(g => g.id) : [],
    kiosk: data.kiosk,
    userStatus: data.userStatus,
  };
}

export const initialState = {
  usersById: {},
};

export const users = (state: Users = initialState, action: any) => {
  switch (action.type) {
    case Actions.GET_USERS_SUCCESS:
      return R.pipe(
        R.assoc(
          'usersById',
          R.mergeRight(
            R.view(R.lensProp('usersById'), state),
            mapArrayToObject(mapValues(action.payload, userFromApiResponse))
          )
        )
      )(state);

    default:
      return state;
  }
};

export default users;
